<template>
    <div class="ModifyNickName">
        <el-dialog
            :title="$t('myAccount.text127')"
            v-model="ModelFlag"
            width='450px'
            custom-class="modify"
            :close-on-click-modal="false"
            destroy-on-close
            >
            <p class="warn">* {{$t('myAccount.text102')}}</p>
            <div class="input-row">
                <div class="label">
                    {{$t('myAccount.text12')}}
                </div>
                <div>
                    <el-input v-model="nickName" :placeholder="$t('myAccount.text103')" />
                </div>
            </div>
             <template #footer>
                  <span class="dialog-footer">
                  <el-button @click="ModelFlag = false">{{$t('trade.text72')}}</el-button>
                  <el-button type="primary" :loading='loading' :disabled="!submitFlag" @click="Confirm"
                      >{{$t('trade.text73')}}</el-button>
                  </span>
              </template>
        </el-dialog>
    </div>
</template>
<script>
import { useStore } from 'vuex';
import apiService from '@/api/request';
import { ElMessage } from 'element-plus'
import {
  ref,computed,inject,onBeforeUnmount
} from 'vue';
import { useI18n } from "vue-i18n";

export default {
    name:'ModifyNickName',
    setup(){
        const ModelFlag = ref(false);
        const store = useStore();
        const emitt = inject('emitt');
        const { t } = useI18n()
        

        const submitFlag = computed(() => {
            return nickName.value != "" && nickName.value.length <= 15
        })

         /**
         * 打开弹框-开始
         */ 
          emitt.$sub('openModifyNickNameModel', (val) => {
            nickName.value = store.getters.userInfo.nickname;
            ModelFlag.value = true;
          });
          onBeforeUnmount(() => {
            emitt.$unsub("openModifyNickNameModel");
          });
        /**
         * 打开弹框-结束
         */ 

        /**
         * 修改昵称-开始
         */
            const nickName = ref('');
            const loading = ref(false);
            
            function Confirm(){
                let params = {
                    nickName:nickName.value
                }
                loading.value = true;
                apiService.AlterNickName(params).then(res => {
                     if(res.status == 1){
                        ModelFlag.value = false;
                        store.dispatch('getUserInfo');
                        ElMessage({
                            message:t('myAccount.text101'),
                            type: 'success',
                        });
                    }else{
                        ElMessage({
                            message: res.message,
                            type: 'error',
                        });
                    }
                    loading.value = false;
                })
            }
        /**
         * 修改昵称-结束
         */
        

        return {
            ModelFlag,
            nickName,
            Confirm,
            submitFlag,
            loading
        }
    }
}
</script>
<style lang="less" scoped>
.ModifyNickName{
    .modify{
        .label{
            line-height: 32px;
        }
        .warn{
            color: @red;
            font-size: 12px;/*no*/
            text-align: center;
        }
        .input-row{
            display: flex;
            justify-content: space-between;
            margin-top: 24px;/*no*/
            .el-input{
                width: 240px;
            }
        }
    }
}
</style>
